import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceRoute } from '../../base/service-route';
import { CommonHttpOption } from '../../base/common-http-option';
import { CoreService } from '../../base/core';
import { ICoupon } from 'src/app/interfaces/coupon';

@Injectable({
  providedIn: 'root'
})
export class CouponService {

  constructor(private core: CoreService) { }

  listOwner(nationalCode: string, studentNationalCode: string, page: number = 1, pageSize: number = 10): Observable<any> {
    nationalCode = nationalCode ? nationalCode : '';
    studentNationalCode = studentNationalCode ? studentNationalCode : '';
    var url = ""
    url = ServiceRoute.coupon.listOwner + "?NationalCode=" + nationalCode + "&studentNationalCode=" + studentNationalCode;
    return this.core.get(
      url,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize, 'Id', true)
    );
  }
  addCoupon(data: ICoupon): Observable<any> {
    return this.core.post(
      ServiceRoute.coupon.addCoupon,
      data,
      new CommonHttpOption().headers
    );
  }
  activeDeactiveCouponAdmin(data: any) {
    return this.core.put(
      ServiceRoute.coupon.activeDeactiveCouponAdmin,
      data,
      new CommonHttpOption().headers
    );
  }
  couponCategory() {
    return this.core.get(
      ServiceRoute.coupon.couponCategory,
      new CommonHttpOption().headers
    );
  }
  addCouponToMyself(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.coupon.addCouponToMyself,
      data,
      new CommonHttpOption().headers
    );
  }
  assignCouponToStudent(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.coupon.assignCouponToStudent,
      data,
      new CommonHttpOption().headers
    );
  }
  listUser(nationalCode: string, company: string, id: number, page: number = 1, pageSize: number = 10): Observable<any> {
    var url = ServiceRoute.coupon.listUser + nationalCode;
    if (id) {
      url += '&id=' + id;
    }
    return this.core.get(url,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
        .append('CompanyEncryptId', company)
    );
  }

  // Student Services
  getListUserSTU(params: any, page: number = 0, pageSize: number = 0): Observable<any> {
    return this.core.get(ServiceRoute.coupon.listUserSTU,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
        .append('CompanyEncryptId', params.CompanyEncryptId)
    );
  }

  listAllUser(nationalCode: string, page: number = 1, pageSize: number = 10): Observable<any> {
    var url = ServiceRoute.coupon.listAllUser + nationalCode;
    return this.core.get(url,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

}
